<template>
  <ValidationObserver>
    <div class="form-group">
      <label for="guest.document.number">{{ $t('document.number') }}</label>
      <ValidationProvider name="številka dokumenta" vid="document.number" v-slot="{ errors }" rules="required">
        <input class="form-control" v-model="guest.document.number" :class="{ 'is-invalid': errors[0] }" :disabled="report && report.status == 1">
        <span class="text-danger">{{errors[0]}}</span>
      </ValidationProvider>
    </div>
    <div class="form-group">
      <label for="guest.document.type">{{ $t('document.type') }}</label>
      <ValidationProvider name="vrsta dokumenta" vid="document.type" v-slot="{ errors }" rules="required">
        <select class="form-control" v-model="guest.document.type" :class="{ 'is-invalid': errors[0] }" :disabled="report && report.status == 1">
          <option value="" disabled selected></option>
          <option v-for="document in documents" v-bind:value="document.value">{{document.text}}</option>
        </select>
        <span class="text-danger">{{errors[0]}}</span>
      </ValidationProvider>
    </div>

    <div class="form-group">
      <label for="guest.touristTax">{{ $t('touristTax') }}</label>
      <ValidationProvider name="turistična taksa" vid="touristTax" v-slot="{ errors }" rules="required">
        <select class="form-control" v-model="guest.touristTax" :class="{ 'is-invalid': errors[0] }" :disabled="report && report.status == 1">
          <option value="" selected disabled></option>
          <option v-for="tax in touristTaxes" v-bind:value="tax.value">{{tax.text}}</option>
        </select>
        <span class="text-danger">{{errors[0]}}</span>
      </ValidationProvider>
    </div>
    <div class="form-group">
      <label for="guest.checkIn.date">{{ $t('checkIn.date') }}</label>
      <ValidationProvider name="check-in date" vid="checkIn.date" v-slot="{ errors }" rules="required">
        <date-picker :input-props='{
                       class: "form-control",
                       disabled: report && report.status == 1
                     }'
                     :firstDayOfWeek="2"
                     @input="changeCheckInDate"
                     v-model="dates.checkIn"
                     :popover="{ placement: 'bottom', visibility: 'click', 'expanded': true }"
                     >
        </date-picker>
        <span class="text-danger">{{errors[0]}}</span>
      </ValidationProvider>
    </div>
    <div class="form-group">
      <label for="guest.checkIn.time">{{ $t('checkIn.time') }}</label>
      <ValidationProvider name="check-in time" vid="checkIn.time" v-slot="{ errors }" rules="required">
        <input class="form-control" v-model="guest.checkIn.time" :class="{ 'is-invalid': errors[0] }" :disabled="report && report.status == 1">
        <span class="text-danger">{{errors[0]}}</span>
      </ValidationProvider>
    </div>
    <div class="form-group">
      <label for="guest.checkOut.date">{{ $t('checkOut.date') }}</label>
      <ValidationProvider name="check-out date" vid="checkOut.date" v-slot="{ errors }" rules="required">
        <date-picker :input-props='{
                       class: "form-control"
                     }'
                     :firstDayOfWeek="2"
                     @input="changeCheckOutDate"
                     v-model="dates.checkOut"
                     :popover="{ placement: 'bottom', visibility: 'click', 'expanded': true }"
                     >
        </date-picker>
        <span class="text-danger">{{errors[0]}}</span>
      </ValidationProvider>
    </div>
    <div class="form-group">
      <label for="guest.checkOut.time">{{ $t('checkOut.time') }}</label>
      <ValidationProvider name="check-out time" vid="checkOut.time" v-slot="{ errors }" rules="required">
        <input class="form-control" v-model="guest.checkOut.time" :class="{ 'is-invalid': errors[0] }">
        <span class="text-danger">{{errors[0]}}</span>
      </ValidationProvider>
    </div>
  </ValidationObserver>
</template>

<script>
  import DatePicker from 'v-calendar/lib/components/date-picker.umd';
  import moment from 'moment';

  export default {
    name: 'Stay',
    props: ['guest', 'dates', 'documents', 'touristTaxes', 'report'],
    data: () => ({
      checkInDate: '',
      checkOutDate: ''
    }),
    components: {
      DatePicker
    },
    mounted(){
      this.checkInDate = moment(this.guest.checkIn.date).toDate();
    },
    methods: {
      changeCheckInDate: function(){
        this.guest.checkIn.date = moment(this.dates.checkIn).format('YYYY-MM-DD')
      },
      changeCheckOutDate: function(){
        this.guest.checkOut.date = moment(this.dates.checkOut).format('YYYY-MM-DD')
      }
    }
  }
</script>

<i18n>
{
  "en": {
    "document": {
      "type": "Document type",
      "number": "Document number"
    },
    "touristTax": "Tourist tax",
    "checkIn": {
      "date": "Check-In Date",
      "time": "Check-In Time"
    },
    "checkOut": {
      "date": "Check-Out Date",
      "time": "Check-Out Time"
    }
  },
  "sl": {
    "document": {
      "type": "Vrsta dokumenta",
      "number": "Številka dokumenta"
    },
    "touristTax": "Turistična taksa",
    "checkIn": {
      "date": "Datum prihoda",
      "time": "Čas prihoda"
    },
    "checkOut": {
      "date": "Datum odhoda",
      "time": "Čas odhoda"
    }
  }
}
</i18n>
